














import {Component, Prop} from 'vue-property-decorator';
import {CardForm} from '@/components/bwaff';
import Form from '@/components/form-base';
import { SecuritylApi } from '../api';

@Component({
  components: {
    CardForm,
  }
})
export default class Password extends Form {
  @Prop() 
  api!: SecuritylApi;

  changePassword() {
    this.bus.emit('open-dialog', { name: 'ChangePassword' });
  }
}
